import axios from "axios";

axios.defaults.baseURL = window.APP_CONFIG.API_BASE_URL;

const handleRpcResponse = (response) => {
  const data = response.data;

  if (data.error) {
    throw new Error(`RPC error ${data.error.code}: ${data.error.message}`);
  }

  // console.log("response :>> ", data.result);

  return data.result;
};

export const userAuthorization = async (userName, password) => {
  const credentials = btoa(`${userName}:${password}`);

  const response = await axios.post("auth", null, {
    headers: {
      Authorization: `Basic ${credentials}`,
    },
  });

  return response.data;
};

export const getInfo = async (token) => {
  const response = await axios.post(
    "v2/rpc",
    {
      jsonrpc: "2.0",
      method: "license/list",
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return handleRpcResponse(response);
};

export const updateCompanyInfo = async (token, company) => {
  const response = await axios.post(
    "v2/rpc",
    {
      jsonrpc: "2.0",
      method: "domain/edit",
      params: {
        ...company,
      },
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return handleRpcResponse(response);
};

export const updateUserInfo = async (token, user) => {
  const response = await axios.post(
    "v2/rpc",
    {
      jsonrpc: "2.0",
      method: "license/edit",
      params: {
        id: user.id,
        activationStatus: user.activationStatus,
        wsEnabled: user.wsEnabled,
        privilege: user.privilege,
      },
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return handleRpcResponse(response);
};

export const createUserByFileData = async (token, file) => {
  const fileContent = await file.text();

  const response = await axios.post(
    "activation/file",
    {
      license: fileContent,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  return response.data;
};

export const createWebSocket = (token, onMessage) => {
  const socket = new WebSocket(window.APP_CONFIG.WS_URL);

  socket.onopen = () => {
    // console.log("WebSocket connected");

    socket.send(
      JSON.stringify({
        heartbeat: 30000,
        token,
      }),
    );
  };

  socket.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);

      // console.log("FROM SERVER :>> ", data);

      onMessage(data);
    } catch (error) {
      console.error("WebSocket message parse error:", error);
    }
  };

  socket.onerror = (error) => {
    console.error("WebSocket error:", error);
  };

  socket.onclose = (event) => {
    console.log("WebSocket closed:", event.code, event.reason);
  };

  return socket;
};

// export const deleteCompany = async (token, companyId) => {
//   const response = await axios.post(
//     "v2/rpc",
//     {
//       jsonrpc: "2.0",
//       method: "license/delete",
//       result: {
//         id: companyId,
//       },
//     },
//     {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     },
//   );

//   return handleRpcResponse(response);
// };

// export const deleteUser = async (token, companyId, userId) => {
//   const response = await axios.post(
//     "v2/rpc",
//     {
//       jsonrpc: "2.0",
//       method: "user/delete",
//       result: {
//         companyId,
//         userId,
//       },
//     },
//     {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     },
//   );

//   return handleRpcResponse(response);
// };
